import { render, staticRenderFns } from "./FormUploadAttachmentMOU.vue?vue&type=template&id=6146b08f"
import script from "./FormUploadAttachmentMOU.vue?vue&type=script&lang=js"
export * from "./FormUploadAttachmentMOU.vue?vue&type=script&lang=js"
import style0 from "./FormUploadAttachmentMOU.vue?vue&type=style&index=0&id=6146b08f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports